import QalaVatSwitcher from './classes/QalaVatSwitcher';

/**
 * Initialize the listeners and handlers.
 */
const qalaVatSwitcher = new QalaVatSwitcher();

qalaVatSwitcher.init();
